<template>
  <div class="page-confirmation">
    <step-breadcrumb :stepIndex="4"/>
    <p v-if="0">{{ $t('Order creation in progress or confirmation information is overdue') }}</p>
    <div class="block-top" v-loading="!orderInfo">
      <div class="block-left">
        <p class="block-title">{{ $t('Reservation Confirmation') }}</p>
        <div class="block-content">

          <div class="hotel-img">
            <img alt="hotel img" :src="orderInfo.hotel_img">
          </div>

          <div class="thank-msg" v-if="orderInfo.rooms">
            <span>{{ $t('Dear') }} {{ orderInfo.rooms[0].Firstname }} {{ orderInfo.rooms[0].Lastname }}{{
                $t(',')
              }}</span>
            <p>
              {{ orderInfo.tips }}
            </p>
          </div>


          <div class="info-table">
            <table>
              <tbody class="general">
              <tr class="mob border-top">
                <td></td>
                <td class="title" colspan="2">{{ $t('GENERAL BOOKING INFORMATION') }}</td>
              </tr>
              <tr class="border-top">
                <td class="title">{{ $t('GENERAL BOOKING INFORMATION') }}</td>
                <td>{{ $t('Your Hotel') }}{{ $t(':') }}</td>
                <td>{{ orderInfo.hotel_name }}</td>
              </tr>
              <tr>
                <td></td>
                <td>{{ $t('Arrival Date') }}{{ $t(':') }}</td>
                <td>{{ orderInfo.arrival }}</td>
              </tr>
              <tr>
                <td></td>
                <td>{{ $t('Departure Date') }}{{ $t(':') }}</td>
                <td>{{ orderInfo.departure }}</td>
              </tr>
              <tr>
                <td></td>
                <td>{{ $t('Number of Night') }}{{ $t(':') }}</td>
                <td>{{ orderInfo.number_of_night }}</td>
              </tr>
              <tr>
                <td></td>
                <td>{{ $t('Number of Rooms') }}{{ $t(':') }}</td>
                <td>{{ orderInfo.number_of_room }}</td>
              </tr>
              </tbody>

              <tbody v-for="(room,roomIndex) of orderInfo.rooms" :key="roomIndex">

              <tr class="mob border-top">
                <td></td>
                <td class="title" colspan="2">{{ $t('ROOM') }} {{ roomIndex + 1 }} {{ $t('INFORMATION') }}</td>
              </tr>
              <tr class="border-top">
                <td class="title">{{ $t('ROOM') }} {{ roomIndex + 1 }} {{ $t('INFORMATION') }}</td>
                <td>{{ $t('Confirmation No.') }}{{ $t(':') }}</td>
                <td>{{ room.confirmation_number }}</td>
              </tr>
              <tr>
                <td></td>
                <td>{{ $t('Title') }}{{ $t(':') }}</td>
                <td>{{ room.Title.name }}</td>
              </tr>
              <tr>
                <td></td>
                <td>{{ $t('Last Name') }}{{ $t(':') }}</td>
                <td>{{ room.Lastname }}</td>
              </tr>
              <tr>
                <td></td>
                <td>{{ $t('First Name') }}{{ $t(':') }}</td>
                <td>{{ room.Firstname }}</td>
              </tr>
              <tr>
                <td></td>
                <td>{{ $t('Place of Residence') }}{{ $t(':') }}</td>
                <td>{{ room.CountryCode.code | langPlace(currentLang) }}</td>
              </tr>
              <tr>
                <td></td>
                <td>{{ $t('Phone Number') }}{{ $t(':') }}</td>
                <td>{{ room.Phone }}</td>
              </tr>
              <tr>
                <td></td>
                <td>{{ $t('Email Address') }}{{ $t(':') }}</td>
                <td>{{ room.Email }}</td>
              </tr>
              <tr v-if="room.ArrivalTime">
                <td></td>
                <td>{{ $t('Arrival Time') }}{{ $t(':') }}</td>
                <td>{{ room.ArrivalTime }}</td>
              </tr>
              <tr>
                <td></td>
                <td>{{ $t('Room Type') }}{{ $t(':') }}</td>
                <td>{{ room.room_group_name }}{{ $t(',') }}{{ room.Roomtype_code.name }}</td>
              </tr>
              <tr>
                <td></td>
                <td>{{ $t('Rate') }}{{ $t(':') }}</td>
                <td>{{ room.Rate_code.name }}</td>
              </tr>

              <tr v-if="room.Special_codes.length">
                <td></td>
                <td>{{ $t('Special Request') }}{{ $t(':') }}</td>
                <td>{{ room.Special_codes.join($t(',')) }}</td>
              </tr>

              <tr v-if="room.comments">
                <td></td>
                <td>{{ $t('Additional Info') }}{{ $t(':') }}</td>
                <td class="comments"><span>{{ room.comments }}</span></td>
              </tr>

              <tr :class="{'add-ons':packIndex===0}" v-for="(pack,packIndex) of room.package" :key="packIndex">
                <td :class="{title:packIndex===0}">{{ packIndex === 0 ? $t('ADD-ONS') + ':' : '' }}</td>
                <td>{{ pack.package_name }}</td>
                <td>{{ pack.quantity }} {{ pack.unit }} ({{ pack.average_price | formatMoney($t(currency)) }} /
                  {{ pack.unit }})
                </td>
              </tr>

              <tr>
                <td colspan="3">
                  <div>
                    <span>{{ $t('Cancellation Policy') }}</span>
                    <div class="cms-style" v-html="room.cancel_rule_remark"></div>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="bottom-action">
          <div class="texts">
            <p class="title">{{ $t('confirmation bottom title') }}</p>
            <p>{{ $t('confirmation bottom text') }}</p>
          </div>
          <div class="links">
            <a :href="`${orderInfo.official_url}`">
              <el-button type="primary">
                {{ $t('Main website') }}
              </el-button>
            </a>
            <el-button type="primary" @click="backSearch">{{ $t('Manage booking') }}</el-button>
          </div>
        </div>
      </div>
      <div class="block-right">
        <p class="block-title">
          {{ $t('Payment Summary') }}
        </p>
        <div class="total">
          <table>
            <tbody v-for="(room,roomIndex) of orderInfo.rooms" :key="roomIndex">
            <tr>
              <td class="title">{{ $t('Room') }} {{ roomIndex + 1 }} {{ $t('Daily Rates') }}{{ $t(':') }}</td>
              <td></td>
            </tr>
            <tr v-for="(price,time,priceIndex) of room.price_detail.price" :key="priceIndex">
              <td>{{ time }}{{ $t(':') }}</td>
              <td>{{ price.price | formatMoney($t(currency)) }}</td>
            </tr>
            <tr>
              <td class="nbsp"></td>
              <td></td>
            </tr>

            <tr>
              <td class="title">{{ $t('Room') }} {{ roomIndex + 1 }} {{ $t('Charges') }}{{ $t(':') }}</td>
              <td></td>
            </tr>
            <tr>
              <td>{{ $t('Total Room Charges') }}{{ $t(':') }}</td>
              <td>{{ room.room_total_price | formatMoney($t(currency)) }}</td>
            </tr>
            <tr>
              <td>{{ $t('Additional Options') }}{{ $t(':') }}</td>
              <td>{{ room.package_total_price | formatMoney($t(currency)) }}</td>
            </tr>
            </tbody>

            <tbody class="sub">
            <tr>
              <td>{{ $t('Sub Total') }}{{ $t(':') }}</td>
              <td>{{ orderInfo.sub_total | formatMoney($t(currency)) }}</td>
            </tr>
            <tr>
              <td>{{ $t('Service Charge') }}{{ $t(':') }}</td>
              <td>{{ orderInfo.service_fee | formatMoney($t(currency)) }}</td>
            </tr>
            <tr>
              <td>{{ $t('Government Tax') }}{{ $t(':') }}</td>
              <td>{{ orderInfo.tax_fee | formatMoney($t(currency)) }}</td>
            </tr>
            <tr>
              <td>{{ $t('Grand Total') }}{{ $t(':') }}</td>
              <td>{{ orderInfo.total | formatMoney($t(currency)) }}</td>
            </tr>
            </tbody>

            <tbody class="online">
            <tr>
              <td>{{ $t('Online Payment') }}{{ $t(':') }} <span
                v-if="orderInfo.deposit_rule_desc">({{ orderInfo.deposit_rule_desc }})</span></td>
              <td>{{ orderInfo.online_payment | formatMoney($t(currency)) }}</td>
            </tr>
            <tr>
              <td>{{ $t('Outstanding Balance') }}{{ $t(':') }}<span>({{ $t('Please pay upon check-in') }})</span></td>
              <td>{{ orderInfo.offline_payment | formatMoney($t(currency)) }}</td>
            </tr>
            </tbody>

          </table>
        </div>
      </div>
      <div class="bottom-action">
        <div class="texts">
          <p class="title">{{ $t('confirmation bottom title') }}</p>
          <p>{{ $t('confirmation bottom text') }}</p>
        </div>
        <div class="links">
          <a :href="`${orderInfo.official_url}`">
            <el-button type="primary">
              {{ $t('Main website') }}
            </el-button>
          </a>
          <el-button type="primary" @click="$router.push({name:'Search'})">{{ $t('Manage booking') }}</el-button>
        </div>
      </div>
    </div>
    <div class="block-bottom" v-if="0">
      <p>{{ $t('Our Recommendations') }}</p>
      <ul>
        <li v-for="serve of 5" :key="serve">
          <div class="img-content">
            <img alt="serve img" src="@/assets/images/temp_serve.png">
          </div>
          <span>Seasonal Themed Buffet</span>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et
            dolore magna aliqua.
          </p>
          <el-button type="primary">{{ $t('LEARN MORE') }}</el-button>
        </li>
      </ul>

    </div>
  </div>
</template>

<script>
const countries = require('../assets/files/countries.json')
import StepBreadcrumb from '@/components/StepBreadcrumb.vue'
import {mapState} from 'vuex'
import util from '@/util'

export default {
  data: function () {
    return {
      orderInfo: '',
      timer: '',
      img: ''
    }
  },
  methods: {
    getOrderInfo() {
      let _this = this
      _this.axios.get('/api/nonemember/pay/confirmation', {
        params: {
          "merchantOrderId": util.getURLParameter('merchantOrderId')
        }
      }).then(
        (res) => {
          if (res.code === 200) {
            _this.orderInfo = res.data
            // this.official_url = this.orderInfo.official_url
          } else if (res.code === 299) {
            setTimeout(() => {
              _this.getOrderInfo()
            }, 1000)
          } else {
            _this.$alert(res.msg, {
                  confirmButtonText: _this.$t('CLOSE'),
                  center: true,
                  callback: () => {
                    _this.$router.push({name: 'Home'})
                  }
            }).then(() => {
                  _this.$router.push({name: 'Home'})
            });
          }
        }
      )
    },
    gaEvent(eventData) {
      const info = eventData
      let rooms = []

      info.rooms.forEach((room) => {
        Object.entries(room.price_detail.price).forEach((x) => {
          //room
          let obj = {
            name: room.room_type_name_en + '+' + room.rate_name_en,
            sku: room.Roomtype_code.code + '+' + room.Rate_code.code,
            price: 0,
            quantity: 1,
            tax: 0,
            serviceFee: 0,
            hotel: room.Hotel_code.code,
            date: '',
          }
          obj.date = x[1].date
          obj.price = x[1].price
          obj.tax = x[1].tax_amount
          obj.serviceFee = x[1].service_amount
          rooms.push(obj)
        })
        //package
        // room.package.forEach((p)=>{
        //   let packageObj = {
        //     name: p.package_name,
        //     sku: p.package_code,
        //     price: p.total_price,
        //     quantity: p.total_quantity,
        //     tax: 0,
        //     hotel: info.hotel_code,
        //     date: '',
        //   }
        //   rooms.push(packageObj)
        // })
      })

      let gaData = {
        currentTimeMacau: localStorage.date || '',
        currentTimeLocal: util.dateStr(new Date(), true),
        currentStep: 4,
        cookieId: '',
        skinCode: this.gaData.skinCode,
        memberLoggedIn: false,
        //step2 data
        checkInDate: info.check_in_date,
        checkOutDate: info.check_out_date,
        selectedHotel: info.hotel_Code,
        numberTotalRooms: info.number_of_room,
        numberTotalAdults: info.adults,
        numberTotalChild: info.children,
        numberTotalNights: info.number_of_night,
        //step3 data
        transactionProducts: rooms,
        //step4 data
        transactionId: info.rooms[0].confirmation_number,
        transactionTotal: info.total,
        transactionTax: info.tax_fee,
        pointsUsed: 0,
        paymentMethod: this.paymentMethod,
        placeOfResidence: info.rooms[0].CountryCode.name
      }

      window.dataLayer.push(gaData)
      window._mtm.push({"event": "booking data ready"})
    },
    backSearch () {
      this.$router.push({
          'name': 'Search',
          query: {
            'skin': this.gaData.skinCode
          },
      })
    }
  },
  created() {
    //this.$root.$children[0].gaInit()
    this.$store.commit('stateChange', {k: 'currency', v: 'MOP'})
    localStorage.setItem("currency", 'MOP');
    this.getOrderInfo()
  },
  components: {
    StepBreadcrumb
  },
  computed: {
    ...mapState(
      ['SearchParams', 'currency', 'dataLayerReady', 'gaData']
    ),
    gaWatcher() {
      const {dataLayerReady, orderInfo} = this
      return {
        dataLayerReady,
        orderInfo
      }
    },
    paymentMethod() {
      let str = 'None'
      let code = this.orderInfo.pay_method
      if (+code === 1 || +code === 2) {
        str = 'creditCard'
      } else if (+code === 6) {
        str = 'unionpay'
      } else {
        switch (code) {
          case 'A':
            str = 'alipay';
            break;
          case 'W':
            str = 'wechatPay';
            break;
          case 'N':
            str = 'noPaymentRequired';
            break;
          case 'P':
            str = 'membershipPoints';
        }
      }
      return str
    },
    currentLang() {
      return this.$i18n.locale
    },
    mainUrl() {
      let url = this.$i18n.locale
      if (url === 'cn') {
        url = 'sc'
      }
      return url
    }
  },
  watch: {
    gaWatcher(obj) {
      if (obj.dataLayerReady && obj.orderInfo) {
        this.gaEvent(obj.orderInfo)
      }
    }
  },
  filters: {
    langPlace(code, lang) {
      let place = countries.find(element => element.code === code)[lang]
      if (lang !== 'en') {
        place = place.split(' - ')[1]
      }
      return place
    }
  }
}

</script>
